import React from 'react';
import { Mail, Truck, DollarSign, Package, Phone } from 'lucide-react';
export function B2BSection() {
  return <section className="bg-gradient-to-b from-gray-50 to-gray-100 py-16 md:py-20" data-id="element-115">
      <div className="max-w-6xl mx-auto px-4" data-id="element-116">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-117">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-118">
            Commercial & Bulk Orders
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-119">
            Dedicated support for industrial buyers with volume pricing and fast
            nationwide fulfillment.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-120">
          <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-121">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4" data-id="element-122">
              <DollarSign className="w-6 h-6 text-blue-700" data-id="element-123" />
            </div>
            <h3 className="font-bold text-gray-900 text-lg mb-2" data-id="element-124">
              Volume Pricing
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-125">
              Competitive wholesale rates on bulk orders. The more you buy, the
              more you save.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-126">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4" data-id="element-127">
              <Truck className="w-6 h-6 text-green-700" data-id="element-128" />
            </div>
            <h3 className="font-bold text-gray-900 text-lg mb-2" data-id="element-129">
              Free Bulk Shipping
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-130">
              Free shipping on qualifying large orders. Multiple warehouse
              locations for faster delivery.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-131">
            <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4" data-id="element-132">
              <Package className="w-6 h-6 text-orange-700" data-id="element-133" />
            </div>
            <h3 className="font-bold text-gray-900 text-lg mb-2" data-id="element-134">
              Fast Fulfillment
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-135">
              Large inventory means quick turnaround. Most orders ship same or
              next business day.
            </p>
          </div>
        </div>

        {/* CTA Card */}
        <div className="bg-gray-800 rounded-2xl p-8 md:p-10 text-center" data-id="element-136">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-137">
            Ready to Place a Bulk Order?
          </h3>
          <p className="text-gray-300 mb-8 max-w-xl mx-auto" data-id="element-138">
            Email us your parts list for a custom quote. Our team responds
            within one business day.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6" data-id="element-139">
            <a href="mailto:sales@usabearingsandbelts.com" className="inline-flex items-center gap-2 bg-red-600 text-white px-8 py-3.5 rounded-lg font-semibold hover:bg-red-700 transition-colors shadow-lg" data-id="element-140">
              <Mail className="w-5 h-5" data-id="element-141" />
              Email Us for Bulk Pricing
            </a>
            <a href="/ProductCatalogSitemap.html" className="inline-flex items-center gap-2 bg-white/10 text-white px-6 py-3.5 rounded-lg font-medium hover:bg-white/20 transition-colors border border-white/20" data-id="element-142">
              Browse Products →
            </a>
          </div>

          <div className="flex items-center justify-center gap-2 text-gray-400" data-id="element-143">
            <Phone className="w-4 h-4" data-id="element-144" />
            <span data-id="element-145">
              Or call <strong className="text-white" data-id="element-146">863-337-4984</strong> •
              M-Fri 9:00-3:00 ET
            </span>
          </div>
        </div>
      </div>
    </section>;
}